import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import UserService from '../service/UserService';

function Navbar() {
    const isAuthenticated = UserService.isAuthenticated(); // Check if the user is authenticated
    const isAdmin = UserService.adminOnly(); // Check if the user is an admin
    const navigate = useNavigate(); // Initialize the useNavigate hook

    const handleLogout = () => {
        const confirmLogout = window.confirm('Are you sure you want to logout?');
        if (confirmLogout) {
            UserService.logout(); // Clear token and role
            navigate('/login'); // Redirect to login page
        }
    };

    return (
        <nav>
            <ul>
                {!isAuthenticated && <li><Link to="/">WHC</Link></li>}
                {isAuthenticated && <li><Link to="/dashboard">Dashboard</Link></li>}
                {isAdmin && <li><Link to="/admin/user-management">Profile Management</Link></li>}
                {isAuthenticated && <li><Link to="/" onClick={handleLogout}>Logout</Link></li>}
            </ul>
        </nav>
    );
}

export default Navbar;
